import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Upload, Button, Icon, Spin, notification, Collapse, Row, Col, Input, Select, DatePicker, Switch } from "antd";
import Webcam from "react-webcam";
import Request, { LAPI_URL, MEDIA_URL } from "../../../request";

const { Panel } = Collapse;

const videoConstraints = {
    width: 480,
    height: 480,
    facingMode: "user",
};

@Form.create()
class AddInquiryModal extends React.Component {
    state = {
        visible: false,
        files: [],
        showWebCam: false,
        imageSrc: null,
        uploading: false,

        genderArr: [],
        maritalArr: [],
        modeArr: [],
        dealingCountryFieldArr: [],

        sendOtpField: false,
        selectedOtpTarget: null,
        showOtpField: false,

        ifWhatsAppNumberIsDifferentSwitch: false,
        ifApplicantHasEmail: true,
        havePassport: false,
        isOtpVerified: false,
    }

    componentDidMount() {
        this.getAllSource();
        this.getAllGenders();
        this.getAllMaritalStatus();
        this.loadDealingCountries();
    }

    getAllSource = async () => {
        let response = await Request.getSourceDetails({ results: 1000, count: 1000, active: true });
        let sourceObject = [];
        if (response && response.data) {
            response.data.map(source => sourceObject.push({ label: source.sourceName, value: source.sourceName }));
        }
        this.setState({ modeArr: sourceObject });
    }

    getAllGenders = async () => {
        let response = await Request.getGenderDetails({ results: 1000, count: 1000 });
        let genderObject = [];
        if (response && response.data) {
            response.data.map(gender => genderObject.push({ label: gender.genderName, value: gender.genderName }));
        }
        this.setState({ genderArr: genderObject });
    }

    getAllMaritalStatus = async () => {
        let response = await Request.getMaritalStatusDetails({ results: 1000, count: 1000 });
        let maritalObject = [];
        if (response && response.data) {
            response.data.map(marital => maritalObject.push({ label: marital.maritalStatus, value: marital.maritalStatus }));
        }
        this.setState({ maritalArr: maritalObject });
    }

    loadDealingCountries = () => {
        let params = { results: 100, sortField: "countryName", sortOrder: "ascend" };
        Request.getDealingCountries({ ...params }).then((resp) => {
            let dealingPhoneCodes = [];
            let dealingCountryPhoneCodes = {};
            let dealingCountryFieldArr = [];
            if (resp && resp.data) {
                resp.data.reduce((temp, vv) => {
                    dealingCountryFieldArr.push({ value: vv._id, label: vv.countryName });
                    if (vv.countryPhoneCode) {
                        dealingCountryPhoneCodes[vv._id] = vv.countryPhoneCode;
                        dealingPhoneCodes.push({ value: vv.countryPhoneCode, label: vv.countryPhoneCode });
                    }
                    temp.push({ ...vv });
                    return temp;
                }, []);
            }
            this.setState({
                dealingCountryArr: resp.data,
                dealingCountryFieldArr: dealingCountryFieldArr,
                dealingPhoneCodes: dealingPhoneCodes,
                dealingCountryPhoneCodes: dealingCountryPhoneCodes
            });
        });
    }

    handleUploadChange = ({ file, fileList }) => {
        let newFileList = fileList.slice(-1);

        if (file.status === 'uploading') {
            this.setState({ uploading: true, showWebCam: false, imageSrc: null });
            return;
        }

        if (file.status === 'done' || file.status === 'error' || file.status === undefined) {
            this.setState({ uploading: false });
        }

        newFileList = newFileList.map(item => {
            if (item.response && item.response.url) {
                item.url = MEDIA_URL + item.response.url;
                item.value = item.response.url;
            }
            return item;
        });

        this.setState({ files: newFileList });

        let path = newFileList.length > 0 ? (newFileList[0].value || '') : '';
        this.props.form.setFieldsValue({ userImage: path });
    };

    setRef = (webcam) => {
        this.webcam = webcam;
    };

    capture = () => {
        if (this.webcam) {
            const imageSrc = this.webcam.getScreenshot();
            this.setState({
                imageSrc: imageSrc,
                showWebCam: false,
                files: [],
                uploading: false
            });
            this.props.form.setFieldsValue({ userImage: imageSrc });
        }
    };

    deleteImage = () => {
        this.setState({ imageSrc: null, files: [], uploading: false });
        this.props.form.setFieldsValue({ userImage: '' });
    };

    // ✅ FIXED: Correctly bound class Arrow Functions preventing "is not a function" crashes
    checkNumberValues = (v) => {
        console.log("Checking Parent Mobile Number Value:", v ? v.target.value : v);
    };

    checkSendOtp = async (value) => {
        let mobile = null;
        if (value === "Student Number") {
            mobile = this.props.form.getFieldValue("mobile");
        } else if (value === "Parent Number") {
            mobile = this.props.form.getFieldValue("parentMobile");
        }
        if (mobile) {
            const response = await Request.sendOTPOnMobile({ mobile });
            if (response && response.OtpSent == true) {
                this.setState({ showOtpField: true, mobile });
                return notification.success({
                    message: "Welcome Code Sent.",
                });
            } else {
                return notification.warning({
                    message: response.msg || "Failed to send Welcome Code",
                });
            }
        }
    };

    verifyOTP = async (e) => {
        let otpValue = e && e.target ? e.target.value : e;
        if (!otpValue) return;
        const response = await Request.verifyOTP({ mobile: this.state.mobile, otpValue });
        if (response && response.OtpVerified == true) {
            this.setState({ isOtpVerified: true, showOtpField: false });
            return notification.success({
                message: "Welcome Code verified.",
            });
        } else {
            return notification.error({
                message: response.message || "Invalid Welcome Code",
            });
        }
    };

    // Dynamic evaluation: Checks if both student and parent mobile numbers are valid
    checkMobileFields = () => {
        const mobile = this.props.form.getFieldValue("mobile");
        const parentMobile = this.props.form.getFieldValue("parentMobile");

        if (mobile && mobile.length >= 10 && parentMobile && parentMobile.length >= 10) {
            this.setState({ sendOtpField: true });
        } else {
            this.setState({ sendOtpField: false, showOtpField: false, selectedOtpTarget: null });
        }
    };

    // Evaluates Welcome Code dropdown selection
    handleOtpTargetChange = (value) => {
        this.props.form.setFieldsValue({ sendOtpTo: value });
        if (value) {
            this.setState({ selectedOtpTarget: value, isOtpVerified: false });
            this.checkSendOtp(value);
        } else {
            this.setState({ selectedOtpTarget: null, showOtpField: false, isOtpVerified: true });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.sendOtpField && !this.state.isOtpVerified) {
                    return notification.error({
                        message: "Please verify the Welcome Code or click Skip OTP.",
                    });
                }

                let finalImagePath = null;

                if (this.state.imageSrc) {
                    finalImagePath = this.state.imageSrc;
                } else if (this.state.files.length > 0) {
                    let files = this.state.files;
                    let file = files[0];
                    if (!file.response) {
                        file.url = file.value;
                        file.path = file.value;
                        delete file.value;
                        delete file.status;
                        files[0] = file;
                    }
                    values.userImage = files;
                }

                const payload = {
                    ...values,
                    studentImage: finalImagePath
                };

                let formData = new FormData();
                formData.append("values", JSON.stringify(payload));
                
                Request.addBasicInquiryV2(formData).then((resp) => {
                    if (resp && !resp.error) {
                        notification.success({ message: `${resp.msg} (ID: ${resp.id})` });
                        this.props.onClose();
                        setTimeout(() => {
                            window.location.href = `/inquiry/editV2?id=${resp.data._id}`;
                        }, 100);
                    } else {
                        notification.error({ message: resp.msg || "Failed to create inquiry" });
                    }
                });
            }
        });
    }

    onCancel = () => {
        this.setState({ files: [], imageSrc: null });
        setTimeout(() => {
            this.props.onClose();
        });
    }

    render() {
        const { form: { getFieldDecorator } } = this.props;
        const { files, showWebCam, imageSrc, uploading } = this.state;
        const { dealingPhoneCodes = [], dealingCountryPhoneCodes = {} } = this.state;

        const previewUrl = imageSrc || (files[0] && (files[0].url || files[0].thumbUrl));

        const guidelinesContent = (
            <ol style={{ paddingLeft: "18px", margin: 0, fontSize: "12px", color: "#595959", lineHeight: "1.8" }}>
                <li>Student Name, Student Email ID, Mobile and Phone number are <b style={{ color: "#d9363e" }}>MANDATORY</b> fields.</li>
                <li>Student Email ID should be of the student only.</li>
                <li>Passport should be valid up-to 6 months from today.</li>
                <li>Birthdate should be entered in dd/mm/yyyy format or pick from Datepicker.</li>
            </ol>
        );

        return (
            <Modal
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div style={{ background: "#e6f7ff", color: "#1890ff", width: 36, height: 36, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Icon type="user-add" style={{ fontSize: 18 }} />
                        </div>
                        <div>
                            <div style={{ fontSize: 18, fontWeight: 700, color: "#1f1f1f", lineHeight: 1.2 }}>Register New Student</div>
                            <div style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 400 }}>Fill in the details to create a new inquiry record</div>
                        </div>
                    </div>
                }
                visible={true}
                onCancel={this.onCancel}
                width={880}
                footer={null}
                style={{ top: 20 }}
                bodyStyle={{ padding: "24px 28px", background: "#f8fafc" }}
            >
                <Form onSubmit={this.handleSubmit} layout="vertical">

                    {/* GUIDELINES BOX */}
                    <div style={{ marginBottom: 20 }}>
                        <Collapse bordered={false} defaultActiveKey={[]} style={{ backgroundColor: "#f0f9ff", border: "1px solid #bae0ff", borderRadius: "8px", overflow: "hidden" }}>
                            <Panel header={<span style={{ color: "#0958d9", fontWeight: 600, fontSize: "12px" }}><Icon type="info-circle" theme="filled" style={{ marginRight: 6, color: "#1677ff" }} /> Click to view Registration Guidelines</span>} key="1">
                                {guidelinesContent}
                            </Panel>
                        </Collapse>
                    </div>

                    {/* IMAGE UPLOAD CARD */}
                    <div style={{ background: "#fff", padding: "16px 20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)" }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#262626", marginBottom: 12 }}>
                            <Icon type="camera" style={{ marginRight: 6, color: "#1890ff" }} /> Student Photograph
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                            <div style={{ width: 90, height: 90, borderRadius: "8px", border: showWebCam ? "2px solid #52c41a" : "1px dashed #d9d9d9", backgroundColor: "#fafafa", display: "flex", justifyContent: "center", alignItems: "center", position: "relative", overflow: "hidden", flexShrink: 0 }}>
                                {uploading && <div style={{ textAlign: "center" }}><Spin size="small" /><div style={{ fontSize: 10, color: "#1890ff", marginTop: 4 }}>Uploading...</div></div>}
                                {!uploading && showWebCam && <Webcam audio={false} ref={this.setRef} screenshotFormat="image/jpeg" videoConstraints={videoConstraints} style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
                                {!uploading && !showWebCam && previewUrl && (
                                    <>
                                        <img src={previewUrl} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="Preview" />
                                        <Icon type="delete" theme="filled" onClick={this.deleteImage} style={{ position: "absolute", top: 4, right: 4, color: "#ff4d4f", background: "#fff", borderRadius: "50%", cursor: "pointer", fontSize: 14, padding: 2, boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }} />
                                    </>
                                )}
                                {!uploading && !showWebCam && !previewUrl && <div style={{ textAlign: "center", color: "#bfbfbf" }}><Icon type="user" style={{ fontSize: 28 }} /><div style={{ fontSize: 10, marginTop: 2 }}>No Image</div></div>}
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    {!showWebCam ? (
                                        <>
                                            {getFieldDecorator("userImage")(<Upload action={`${LAPI_URL}/filesUploader`} beforeUpload={() => true} onChange={this.handleUploadChange} showUploadList={false} disabled={uploading}><Button size="medium" icon="upload" loading={uploading}>{uploading ? "Uploading..." : "Upload Photo"}</Button></Upload>)}
                                            <Button size="medium" type={previewUrl ? "default" : "primary"} icon="camera" onClick={() => this.setState({ showWebCam: true })} disabled={uploading}>{previewUrl ? "Retake Photo" : "Use Webcam"}</Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button type="primary" size="medium" icon="camera" onClick={this.capture}>Capture Now</Button>
                                            <Button size="medium" type="danger" ghost onClick={() => this.setState({ showWebCam: false })}>Cancel Camera</Button>
                                        </>
                                    )}
                                </div>
                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>
                                    {uploading ? "Processing server upload..." : previewUrl && !showWebCam ? "Photograph captured successfully!" : showWebCam ? "Position student face in center" : "Allowed formats: JPG, PNG. Max size: 2MB"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* PERSONAL DETAILS CONTAINER */}
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #1890ff" }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#1f1f1f", marginBottom: 16, display: "flex", alignItems: "center" }}>
                            <Icon type="idcard" style={{ marginRight: 8, color: "#1890ff" }} /> Personal Details
                        </div>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Full Name <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("studentName", { rules: [{ required: true, message: "Enter full name" }] })(<Input placeholder="Enter Full Name" size="large" />)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Date Of Birth <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("dateOfBirth", { rules: [{ required: true, message: "Select date of birth" }] })(<DatePicker style={{ width: '100%' }} size="large" format="DD/MM/YYYY" placeholder="Select DOB" />)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Gender <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("gender", { rules: [{ required: true, message: "Select gender" }] })(
                                        <Select placeholder="Select Gender" size="large" onChange={(v) => this.props.form.setFieldsValue({ gender: v })}>
                                            {this.state.genderArr.map(g => <Select.Option key={g.value} value={g.value}>{g.label}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Marital Status <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("maritalStatus", { rules: [{ required: true, message: "Select status" }] })(
                                        <Select placeholder="Select Marital Status" size="large" onChange={(v) => this.props.form.setFieldsValue({ maritalStatus: v })}>
                                            {this.state.maritalArr.map(g => <Select.Option key={g.value} value={g.value}>{g.label}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>How did you come to know about us? <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("mode", { rules: [{ required: true, message: "Select source mode" }] })(
                                        <Select placeholder="Select Lead Source" showSearch size="large" onChange={(v) => this.props.form.setFieldsValue({ mode: v })}>
                                            {this.state.modeArr.map(g => <Select.Option key={g.value} value={g.value}>{g.label}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>

                    {/* CONTACT DETAILS CONTAINER */}
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #52c41a" }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#1f1f1f", marginBottom: 16, display: "flex", alignItems: "center" }}>
                            <Icon type="phone" style={{ marginRight: 8, color: "#52c41a" }} /> Contact Details
                        </div>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Country <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("addressCountryId", { rules: [{ required: true, message: "Select country" }] })(
                                        <Select placeholder="Select Country" showSearch size="large" onChange={(v) => {
                                            if (dealingCountryPhoneCodes) {
                                                let phoneCodeValue = (dealingCountryPhoneCodes[v] !== undefined ? dealingCountryPhoneCodes[v] : '');
                                                this.props.form.setFieldsValue({ countryCode: phoneCodeValue });
                                            }
                                            this.props.form.setFieldsValue({ addressCountryId: v });
                                        }}>
                                            {this.state.dealingCountryFieldArr.map(g => <Select.Option key={g.value} value={g.value}>{g.label}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Mobile Number <span style={{ color: "red" }}>*</span></span>}>
                                    <Input.Group compact>
                                        {getFieldDecorator("countryCode")(
                                            <Select size="large" style={{ width: '32%' }} disabled>
                                                {dealingPhoneCodes.map(g => <Select.Option key={g.value} value={g.value}>{g.label}</Select.Option>)}
                                            </Select>
                                        )}
                                        {getFieldDecorator("mobile", { rules: [{ required: true, message: "Enter mobile number" }] })(
                                            <Input
                                                style={{ width: '68%' }}
                                                placeholder="Mobile Number"
                                                size="large"
                                                type="number"
                                                onChange={() => setTimeout(this.checkMobileFields, 100)}
                                                onBlur={v => {
                                                    if (v.target.value.length < 10) {
                                                        notification.error({ message: "Mobile number must be at least 10 digits long." });
                                                    }
                                                    this.checkMobileFields();
                                                }}
                                            />
                                        )}
                                    </Input.Group>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Parents Number <span style={{ color: "red" }}>*</span></span>}>
                                    {getFieldDecorator("parentMobile", { rules: [{ required: true, message: "Enter parents number" }] })(
                                        <Input
                                            placeholder="Parents Number"
                                            size="large"
                                            type="number"
                                            onChange={() => setTimeout(this.checkMobileFields, 100)}
                                            onBlur={v => {
                                                if (v.target.value.length < 10) {
                                                    notification.error({ message: "Mobile number must be at least 10 digits long." });
                                                } else {
                                                    this.checkNumberValues(v);
                                                }
                                                this.checkMobileFields();
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            {/* Welcome Code To only appears when both Student Mobile and Parent Mobile are filled */}
                            {this.state.sendOtpField && (
                                <Col span={12}>
                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Welcome Code To <span style={{ color: "red" }}>*</span></span>}>
                                        {getFieldDecorator("sendOtpTo", { rules: [{ required: true, message: "Select recipient" }] })(
                                            <Select
                                                size="large"
                                                placeholder="Select recipient to send code"
                                                onChange={this.handleOtpTargetChange}
                                            >
                                                <Select.Option value="Student Number">Student Number</Select.Option>
                                                <Select.Option value="Parent Number">Parent Number</Select.Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>

                        {/* Enter Welcome Code Input + Skip Button appear ONLY when "Welcome Code To" dropdown is selected */}
                        {this.state.showOtpField && (
                            <Row gutter={16} style={{ background: "#f6ffed", padding: "12px 8px 0px 8px", borderRadius: "8px", border: "1px dashed #b7eb8f", marginBottom: "16px" }}>
                                <Col span={16}>
                                    <Form.Item label={<span style={{ fontWeight: 600, color: "#276749" }}>Enter Welcome Code <span style={{ color: "red" }}>*</span></span>}>
                                        {getFieldDecorator("otp", { rules: [{ required: true, message: "Enter OTP code" }] })(
                                            <Input placeholder="Enter 6-digit OTP" size="large" type="number" onBlur={v => this.verifyOTP(v)} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} style={{ display: "flex", alignItems: "center", paddingTop: "8px" }}>
                                    <Button
                                        size="large"
                                        type="default"
                                        style={{ width: "100%", borderColor: "#d9d9d9", color: "#595959" }}
                                        onClick={() => this.setState({ showOtpField: false, isOtpVerified: true })}
                                    >
                                        Skip OTP
                                    </Button>
                                </Col>
                            </Row>
                        )}

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Does Applicant have Email?</span>}>
                                    {getFieldDecorator("ifApplicantHasEmail", { initialValue: "Yes" })(
                                        <Select size="large" onChange={v => {
                                            this.setState({ ifApplicantHasEmail: v === "Yes" });
                                            this.props.form.setFieldsValue({ ifApplicantHasEmail: v });
                                        }}>
                                            <Select.Option value="Yes">Yes</Select.Option>
                                            <Select.Option value="No">No</Select.Option>
                                            <Select.Option value="Asked But Not Given">Asked But Not Given</Select.Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            {this.state.ifApplicantHasEmail !== false && (
                                <Col span={12}>
                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Email Address <span style={{ color: "red" }}>*</span></span>}>
                                        {getFieldDecorator("emailId", { rules: [{ required: true, message: "Enter email address" }, { type: "email", message: "Invalid email address" }] })(
                                            <Input placeholder="Enter Email Address" size="large" prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} />
                                        )}
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>

                        <Row gutter={16} style={{ alignItems: "center" }}>
                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Is WhatsApp Number different?</span>} style={{ marginBottom: 0 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                        {getFieldDecorator("ifWhatsAppNumberIsDifferentSwitch", { valuePropName: 'checked', initialValue: false })(
                                            <Switch onChange={v => {
                                                this.setState({ ifWhatsAppNumberIsDifferentSwitch: v });
                                                this.props.form.setFieldsValue({ ifWhatsAppNumberIsDifferentSwitch: v });
                                            }} />
                                        )}
                                        <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.ifWhatsAppNumberIsDifferentSwitch ? "Yes, enter below" : "No, same as mobile"}</span>
                                    </div>
                                </Form.Item>
                            </Col>

                            {this.state.ifWhatsAppNumberIsDifferentSwitch && (
                                <Col span={12}>
                                    <Form.Item label={<span style={{ fontWeight: 600 }}>WhatsApp Number <span style={{ color: "red" }}>*</span></span>} style={{ marginBottom: 0 }}>
                                        {getFieldDecorator("watsupp", { rules: [{ required: true, message: "Enter WhatsApp number" }] })(
                                            <Input placeholder="Enter WhatsApp Number" size="large" type="number" prefix={<Icon type="whatsapp" style={{ color: '#52c41a' }} />} />
                                        )}
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>
                    </div>

                    {/* ADDITIONAL DETAILS CONTAINER */}
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 24, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #722ed1" }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#1f1f1f", marginBottom: 16, display: "flex", alignItems: "center" }}>
                            <Icon type="file-protect" style={{ marginRight: 8, color: "#722ed1" }} /> Passport Details
                        </div>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Do you have a Passport?</span>}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                        {getFieldDecorator("havePassport", { valuePropName: 'checked', initialValue: false })(
                                            <Switch onChange={v => {
                                                this.props.form.setFieldsValue({ havePassport: v }, () => {
                                                    this.setState({ havePassport: v });
                                                });
                                            }} />
                                        )}
                                        <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.havePassport ? "Yes, I have passport" : "No passport yet"}</span>
                                    </div>
                                </Form.Item>
                            </Col>

                            {this.state.havePassport && (
                                <Col span={12}>
                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Passport Number <span style={{ color: "red" }}>*</span></span>}>
                                        {getFieldDecorator("passport", { rules: [{ required: true, message: "Enter passport number" }] })(
                                            <Input placeholder="Enter Passport Number" size="large" style={{ textTransform: "uppercase" }} />
                                        )}
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>
                    </div>

                    {/* FORM FOOTER ACTIONS */}
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" }}>
                        <Button size="large" onClick={this.onCancel} style={{ minWidth: 110, borderRadius: "6px" }}>
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit" size="large" style={{ minWidth: 200, borderRadius: "6px", height: 42, fontSize: 15, fontWeight: 600 }}>
                            Register New Student
                        </Button>
                    </div>

                </Form>
            </Modal>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddInquiryModal);